import React, { FunctionComponent, useState } from 'react';
import { Icon, Button, Notification, Popup } from '@scuf/common';
import { ReactComponent as RedTick } from '../../../../images/red-tick.svg';
import { ReactComponent as YellowTick } from '../../../../images/yellow-tick.svg';
import { ReactComponent as GreenTick } from '../../../../images/green-tick.svg';
import { USER_ROLE } from '../../../../constants/constants';
import moment from 'moment';
import './ReviewCompletion.scss';

const TRAINING_REQUIRED_ACTION_TYPE = 'acceptanddropdown';

export interface IFileDetailModal {
    activity_id: number,
    file_name: string,
    stored_file_name: string,
    created_on: string
}

interface IReviewCompletionContentProps {
    insightID: number;
    actionStatus: string;
    isExpanded: boolean;
    totalNoOfDays: number;
    targetDate: string;
    actionOwnerId: string;
    orgOwnerComment: string;
    actionOwnerComment: string;
    handleFileDownload: Function;
    actionOwnerHid: string;
    uploadedFileDetails?: IFileDetailModal[] | null;
    handleReviewCheckBox: Function;
    userRole?: string;
    reasonTitle?: string;
    actionType?: string;
    trainingName?: string;
}

const ReviewCompletionContent: FunctionComponent<IReviewCompletionContentProps> = (props) => {

    const [isExpanded, setIsExpanded] = useState<boolean>(props.isExpanded);

    const expandOnClickHandle = () => {
        isExpanded ? setIsExpanded(false) : setIsExpanded(true);
    }

    const handleFileDownloadFunctionality = (insight_id: number, stored_file_name: string, file_name: string) => {

        props.handleFileDownload(insight_id, stored_file_name, file_name);

    }

    const handleCheckBoxForRemainder = (e: any) => {

        props.handleReviewCheckBox(e, props.actionOwnerHid);

    }

    const isTrainingRequiredReason =
        props.actionType === TRAINING_REQUIRED_ACTION_TYPE &&
        (props.reasonTitle || '').toString().trim().toLowerCase().includes('training required');

    return (
        <>
            <div className="review__completion--reasoncontent">
                {(props.actionStatus == null||props.actionStatus == "white") ? (props.userRole === USER_ROLE.ORG_USER && <input type='checkbox' className='review__completion--checkbox' onChange={handleCheckBoxForRemainder}></input>) : ''}
                {<div className='review__completion--actionemail' >{props.actionOwnerId}</div>}
                <div className='review__completion--actionstatus'>{(props.actionStatus === null||props.actionStatus == "white") ? <RedTick /> : (props.actionStatus === 'yellow' ? <Popup position="bottom center" element={<YellowTick />} on="hover">
                    <Notification
                        className='review__completion--notification'
                        hasIcon={true}
                        title={`Target Date Missed by ${props.totalNoOfDays} Days`}
                        severity="important">
                        Action Owner couldn't complete the task. Target Date was {props.targetDate}
                    </Notification>
                </Popup> : (props.actionStatus === 'green' ? <GreenTick /> : ''))}</div>
                <Button
                    className='review__completion--collapse'
                    size="small"
                    type="link"
                    onClick={expandOnClickHandle}
                >
                    {isExpanded ? <Icon root="building" name="caret-down" size="small" /> : <Icon root="building" name="caret-right" size="small" />}
                </Button>
            </div>
            {isTrainingRequiredReason && (
                <div className='review__completion--traininginfo'>
                    <div>
                        <span className='review__completion--commentheader'>Training Name: </span>
                        <span className='review__completion--commentscontent'>{props.trainingName || 'Not Assigned'}</span>
                    </div>
                    <div>
                        <span className='review__completion--commentheader'>Target Date: </span>
                        <span className='review__completion--commentscontent'>{props.targetDate ? moment(props.targetDate).format('MM/DD/YYYY') : ''}</span>
                    </div>
                </div>
            )}
            {isExpanded ?
                <> <div className='review__completion--comments'>
                    <span className='review__completion--commentheader'> Comments Given by Action Owner: </span>
                    <span className='review__completion--commentscontent'> {props.actionOwnerComment}</span></div>
                    {<div className='review__completion--attachments' ><span className='review__completion--commentheader'>Attachments from Action Owner: </span> <span className='review__completion--attachmentcontent'>{props.uploadedFileDetails && props.uploadedFileDetails.length > 0 && props.uploadedFileDetails.map((item) => {
                        if (item !== null) {
                            return <div>
                                <span className='truncate-text'>
                                    {item && item.file_name}
                                </span>
                                {item &&
                                    <Icon
                                        root="common"
                                        color="blue"
                                        name="cloud-download"
                                        size="small"
                                        className="download_icon"
                                        onClick={() =>
                                            handleFileDownloadFunctionality(props.insightID, item.stored_file_name, item.file_name)
                                        }
                                    />
                                }
                            </div>
                        }
                    })}</span>
                    </div>}
                    <div className='review__completion--comments'><span className='review__completion--commentheader'>Comments Given by Org Owner:</span> <span className='review__completion--commentscontent'>{props.orgOwnerComment}</span></div> </>
                : ''}
        </>
    );
};
export default ReviewCompletionContent;




